/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { CommonModule } from '@angular/common'
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { PidxLoaderComponent } from './pidx-loader.component'
import { PorscheDesignSystemModule } from '@porsche-design-system/components-angular'

@NgModule({
  declarations: [PidxLoaderComponent],
  imports: [CommonModule, PorscheDesignSystemModule],
  exports: [PidxLoaderComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PidxLoaderModule {}
